import { FormBase } from 'core/components';

export default class ImportCreateForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'file',
                    label: 'IMPORT.UPLOAD.FILE_LABEL',
                    placeholder: 'IMPORT.UPLOAD.FILE_PLACEHOLDER',
                    type:'file'
                },
                {
                    name: 'facility',
                    label: 'IMPORT.UPLOAD.FACILITY_LABEL',
                    placeholder: 'IMPORT.UPLOAD.FACILITY_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'scheduledDate',
                    label: 'IMPORT.UPLOAD.SCHEDULED_DATE_LABEL',
                    placeholder: 'IMPORT.UPLOAD.SCHEDULED_DATE_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'dateOfService',
                    label: 'IMPORT.UPLOAD.DATE_OF_SERVICE_LABEL',
                    placeholder: 'IMPORT.UPLOAD.DATE_OF_SERVICE_PLACEHOLDER'
                }
            ],
        };
    }
}
